import testCardsTransform from "../helpers/testCardsTransform";
import { useSelfcare } from "modules/selfcare/hooks/useSelfcare";

export function useTestCards() {
  const { data } = useSelfcare(false);

  return data && testCardsTransform(data.test_cards);
}
